export const DASHBOARD_CHART_CSS_VARS = {
  credentialIssued: "--dashboard-chart-credential-issued-color",
  credentialRevoked: "--dashboard-chart-credential-revoked-color",
  credentialFailed: "--dashboard-chart-credential-failed-color",
  credentialExpired: "--dashboard-chart-credential-expired-color",
  sliceBorder: "--dashboard-chart-slice-border-color",
  dataLabelText: "--dashboard-chart-data-label-text-color",
  barGradientStart: "--dashboard-chart-bar-gradient-start-color",
  barGradientEnd: "--dashboard-chart-bar-gradient-end-color",
  axisLabel: "--dashboard-chart-axis-label-color",
  gridLabel: "--dashboard-chart-grid-label-color",
};

export const cssVar = (variableName) => `var(${variableName})`;
